import { Locale } from '../interface'

const locale: Locale = {
  'DatePicker.placeholder': '请选择日期',
  'DatePicker.yearPlaceholder': '请选择年份',
  'DatePicker.quarterPlaceholder': '请选择季度',
  'DatePicker.monthPlaceholder': '请选择月份',
  'DatePicker.weekPlaceholder': '请选择周',
  'DatePicker.timePlaceholder': '请选择时间',
  'DatePicker.now': '此刻',
  'DatePicker.confrim': '确定',
  'DatePicker.today': '今天',
  'DatePicker.month': '月',
  'DatePicker.year': '年',
  'DatePicker.weekTitle': ['日', '一', '二', '三', '四', '五', '六'],
  'DatePicker.monthTitle': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  'DatePicker.rangePlaceholder': ['开始日期', '结束日期'],
  'DatePicker.rangeYearPlaceholder': ['开始年份', '结束年份'],
  'DatePicker.rangeMonthPlaceholder': ['开始月份', '结束月份'],
  'DatePicker.rangeWeekPlaceholder': ['开始周', '结束周'],
  'DatePicker.rangeQuarterPlaceholder': ['开始季度', '结束季度'],
  'DatePicker.rangeTimePlaceholder': ['开始时间', '结束时间'],
  'DatePicker.monthBeforeYear': false,
}

export default locale
